import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const TelegramBotUserPages = {
  list: 'ListTelegramBotUser',
  add: 'AddTelegramBotUser',
  edit: 'EditTelegramBotUser',
}

const title = t('pages.listTelegramBotUser')
const path = '/telegram-bot-user'
const breadcrumb = [{ title, path }]

const telegramBotUserComponent = () =>
  import('@/pages/mainPageWithRoute/telegram-bot-user/FormTelegramBotUser.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: TelegramBotUserPages.add,
  component: telegramBotUserComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: TelegramBotUserPages.edit,
  component: telegramBotUserComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: TelegramBotUserPages.list,
  component: () =>
    import('@/pages/mainPageWithRoute/telegram-bot-user/ListTelegramBotUserPage.vue'),
  meta: { title, requiresAuth: true },
}

export const TelegramBotUsers: RouteRecordRaw = {
  path,
  name: 'TelegramBotUsers',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
